import HistoryApprovalTable from './HistoryApprovalTable';

export default HistoryApprovalTable; 
